<template>
  <div class="page-content contact-page-container" :class="{ 'is-submitted': messagesent }">
    <figcaption class="page-header-description topbottom">CONTACT</figcaption>

    <div class="contact-content" v-if="!messagesent">
      <div class="contact-form-wrap">
        <h1>Drop us a line.</h1>
        <div class="form-card">
          <b-form @submit="onSubmit">
            <input type="text" v-model="form.website" tabindex="-1" autocomplete="off" class="hp-field" aria-hidden="true" />

            <div class="form-row two-col">
              <div class="form-element">
                <label for="firstName">First Name<span>*</span></label>
                <input type="text" id="firstName" name="firstName" required v-model="form.firstName" />
              </div>
              <div class="form-element">
                <label for="lastName">Last Name<span>*</span></label>
                <input type="text" id="lastName" name="lastName" required v-model="form.lastName" />
              </div>
            </div>

            <div class="form-row two-col">
              <div class="form-element">
                <label for="email">Email<span>*</span></label>
                <input type="email" id="email" name="email" required v-model="form.email" />
              </div>
              <div class="form-element">
                <label for="phone">Phone Number<span>*</span></label>
                <input type="tel" id="phone" name="phone" required v-model="form.phone" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-element">
                <label for="business">Business Name<span>*</span></label>
                <input type="text" id="business" name="business" required v-model="form.business" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-element reach-by">
                <label>I can best be reached by</label>
                <div class="reach-options">
                  <button type="button" v-for="option in reachOptions" :key="option" class="reach-btn" :class="{ active: form.reachBy === option }" @click="form.reachBy = option">
                    {{ option }}
                  </button>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-element">
                <label for="comment">Tell us how we can help you<span>*</span></label>
                <textarea id="comment" name="comment" required rows="6" v-model="form.comment"></textarea>
              </div>
            </div>

            <p v-if="errorMessage" class="form-error">{{ errorMessage }}</p>

            <div class="form-row submit-row">
              <button type="submit" class="submit-btn" :disabled="sending">
                {{ sending ? "SENDING..." : "SEND MESSAGE" }}
              </button>
            </div>
          </b-form>
        </div>
      </div>

      <div class="contact-aside">
        <div class="contact-aside-content">
          <div class="aside-block">
            <h2>Call us</h2>
            <p><a href="tel:+5194716778">519.471.6778</a></p>
          </div>

          <div class="aside-block">
            <p class="address">
              122 Chestnut Place<br />
              London, Ontario, Canada<br />
              N6K 4J6
            </p>
          </div>

          <div class="aside-block career-cta">
            <p>Careers &ndash; Start your career <router-link to="/careers">here</router-link></p>
          </div>
        </div>
      </div>
    </div>

    <div class="thank-you-screen" v-if="messagesent">
      <div class="thank-you-content">
        <h1>Thanks &mdash; We&rsquo;ve Received Your Message</h1>
        <p class="lead">
          We&rsquo;ve successfully received your inquiry and a member of our team will get back to you within 1&ndash;2 business days.
        </p>
        <h3>What&rsquo;s Next</h3>
        <ul class="next-steps">
          <li>We review your project details</li>
          <li>The right team member follows up</li>
          <li>We connect with you via email or phone</li>
        </ul>
        <p class="urgent">
          <strong>If your request is urgent, please contact us directly and we&rsquo;ll prioritize your message.</strong>
        </p>
        <p>Thanks again &mdash; we look forward to connecting with you.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
    // eslint-disable-next-line
    axios,
  },
  metaInfo: {
    titleTemplate: `Contact Branton — A Creative Design Agency`,
    meta: [
      {
        name: "Contact Us",
        content: "Ready to start something great together? The Branton team would love to hear from you. Drop us a line and we'll get back to you.",
      },
    ],
  },
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        business: "",
        reachBy: "Email",
        comment: "",
        website: "",
      },
      reachOptions: ["Email", "Phone", "Text"],
      messagesent: false,
      sending: false,
      errorMessage: "",
    };
  },
  mounted() {
    this.$gtag.pageview({
      page_path: "/contact",
    });
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      if (this.sending) return;
      this.errorMessage = "";
      this.sending = true;
      try {
        await axios.post(process.env.VUE_APP_CONTACT_API, this.form);
        this.messagesent = true;
      } catch (err) {
        this.errorMessage =
          (err.response && err.response.data && err.response.data.error) ||
          "Something went wrong sending your message. Please try again or email info@branton.ca.";
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/css/contact.scss";
</style>
